import React from "react";

const Divider = props => (
  <li className="neeto-ui-dropdown__popup-divider" {...props} />
);

export default Divider;
